import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Regional from "../components/Regional";
import WhatWeOffer from "../components/WhatWeOffer";
import Services from "../components/Services";
import Capabilities from "../components/Capabilities";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Contact from "../components/Contact";
import BlogSection from "../components/BlogSection";
import { api } from "../lib/api";

export default function Home() {
  const [content, setContent] = useState({});
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    Promise.all([api.getContent(), api.getProjects()])
      .then(([c, p]) => {
        if (!mounted) return;
        setContent(c || {});
        setProjects(p || []);
      })
      .catch((err) => {
        console.error("Home page failed to load content:", err);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-onyx-900" data-testid="home-loading">
        <div className="font-cinzel text-[10px] tracking-[0.4em] uppercase text-gold shimmer px-6 py-3">
          Loading Dhadda
        </div>
      </div>
    );
  }

  return (
    <div className="bg-onyx-900 text-ivory min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero data={content.hero || {}} />
        <Regional data={content.regional || {}} />
        <WhatWeOffer />
        <Services data={content.services || {}} />
        <Capabilities />
        <Portfolio projects={projects} />
        <About data={content.about || {}} />
        <BlogSection />
        <Contact data={content.contact || {}} />
      </main>
      <Footer contact={content.contact || {}} settings={content.settings || {}} />
    </div>
  );
}
